import React, { useMemo, useState } from 'react'
import InnFormItem from '../../Common/FormItems/InnFormItem'
import { errors, profileScreen } from '../../../translates'
import { validateFullInn, validateInn } from '../../../helper'
import { useStores } from '../../../Store/Store'
// import LegalFormItem from '../../Common/FormItems/LegalFormItem/LegalFormItem'
import ModalMyTaxApp from './ModalMyTaxApp/ModalMyTaxApp'
import { individual, innDetailsStatusCodes, selfEmployed } from '../../../AppConfig'
import { flowV2Steps } from './ProfileV2'
import CorrectInfo from './ErrorStep/CorrectInfo'
import LegalFormItemV2 from '../../Common/FormItems/LegalFormItemV2/LegalFormItem'
// import { Button, Form } from 'antd'
import TaxSystemItem from '../../Common/FormItems/TaxSystemItem/TaxSystemItem'

function InnStep ({ form }) {
  const {
    partnerProfile: {
      profile
    } = {}
  } = useStores()
  const [legalForm, setLegalForm] = useState(profile?.personalData?.legalForm)
  const isIndividual = legalForm === individual
  const isSelfEmployed = legalForm === selfEmployed
  const isIndividualProfileSet = profile?.personalData?.legalForm === individual
  const isInnDeclinedStatus = profile?.innDetails?.status === innDetailsStatusCodes.declined
  const isDisabledInn = useMemo(() => {
    return profile?.innDetails?.inn
  }, [profile?.innDetails?.inn])

  return (
    <>
      <CorrectInfo step={flowV2Steps.innStep} />

      <LegalFormItemV2 required onChange={setLegalForm} disabled={isIndividualProfileSet} />

      {isIndividual && <TaxSystemItem form={form} isDisabled={isInnDeclinedStatus} />}

      {(isIndividualProfileSet || isSelfEmployed) && (
        <InnFormItem
          label={profileScreen.input.inn.label}
          placeholder={profileScreen.input.inn.placeholder}
          rules={[
            { required: profile?.personalData?.required, message: profileScreen.input.inn.message, validator: validateInn },
            { message: errors.innCheckSum, validator: (rule, value) => validateFullInn({ rule, inn: value }) }
          ]}
          classNameInput='noScrollNumber'
          disabled={isDisabledInn}
        />
      )}

      <ModalMyTaxApp />
    </>
  )
}

export default InnStep
